import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { getBishopDetails } from '../../../../../global/ducks/organization-prc-api';
import { setBishopDetails } from '../new-hire-slice';

export function useNewHireBishopDetails() {
	const dispatch = useDispatch();    
    const bishopDetailsLoaded = useSelector<TcsmStates, boolean>(state => state?.newHireState?.bishopDetailsLoaded);

    useEffect(() => {
        if (!bishopDetailsLoaded) {            
            dispatch(getBishopDetails(                
                (response)=>{
                    dispatch(setBishopDetails(response?.data));
                })); 
        }
    }, [bishopDetailsLoaded]);

    return bishopDetailsLoaded;
}